import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import Contacts from "./Pages/Contactus";
import Aboutus from './Pages/aboutus';
import Register from "./components/auth/Register";
import Login from "./components/auth/Login";
import ResetPassword from "./components/auth/ResetPassword";
import AdminDashboard from './admin/AdminDashboard';
import AdminPackages from './admin/AdminPackages';
import Adminservices from './admin/Adminservices';
import AdminsubServices from './admin/AdminsubServices';
import OrderPage from './admin/Order';
import ServicePage from "./Pages/services";
import { PackagesProvider } from "./context/PackagesContext";
import ProtectedRoute from './admin/ProtectedRoute';
import { HelmetProvider } from "react-helmet-async";
import PaymentProof from "./Pages/PaymentProof";
import ScrollToTop from "./components/ScrollToTop";
import AddAdmin from './admin/AddAdmin';

function App() {
  return (
    <HelmetProvider>
      <PackagesProvider>
        <Router>
        <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contactus" element={<Contacts />} />
            <Route path="/aboutus" element={<Aboutus />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/AdminDashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/AdminPackages" element={<ProtectedRoute><AdminPackages /></ProtectedRoute>} />
            <Route path="/Adminservices" element={<ProtectedRoute><Adminservices /></ProtectedRoute>} />
            <Route path="/AdminsubServices" element={<ProtectedRoute><AdminsubServices /></ProtectedRoute>} />
            <Route path="/AddAdmin" element={<ProtectedRoute>< AddAdmin /></ProtectedRoute>} />
            <Route path="/Orders" element={<ProtectedRoute><OrderPage /></ProtectedRoute>} />
            <Route path="/services/:id" element={<ServicePage />} />
            <Route path="/upload-receipt/:token" element={<PaymentProof />} />
           

          </Routes>
        </Router>
      </PackagesProvider>
    </HelmetProvider>
  );
}

export default App;
